// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup.popup--subscribed .popup__content {
  position: relative;
  margin: auto;
}

.popup.visible.popup--subscribed .popup__wash {
  opacity: 1;
  pointer-events: all;
  cursor: pointer;
}

.popup--subscribed {
  pointer-events: none;
}

.popup.popup--subscribed .popup__text-container {
  position: absolute;
  bottom: 0;
  width: 100%;
}
.popup.popup--subscribed .popup__text-container .popup__heading {
  text-transform: unset;
}
.popup.popup--subscribed .popup__image {
  position: relative;
}
.popup.popup--subscribed .popup__image .image__inner {
  position: relative;
}
.popup.popup--subscribed .popup__image .image__inner .image__img {
  position: relative;
}

.popup.visible.popup--subscribed .popup__wash {
  cursor: default;
}

@media (max-width: 719px) {
  .popup.visible.popup--subscribed .popup__wash {
    position: fixed;
    pointer-events: all;
    cursor: pointer;
  }
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/popup/popup.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,YAAA;AAAF;;AAGA;EACE,UAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,oBAAA;AAAF;;AAIE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AADJ;AAGI;EACE,qBAAA;AADN;AAKE;EACE,kBAAA;AAHJ;AAKI;EACE,kBAAA;AAHN;AAKM;EACE,kBAAA;AAHR;;AASA;EACE,eAAA;AANF;;AASA;EACE;IACE,eAAA;IACA,mBAAA;IACA,eAAA;EANF;AACF","sourcesContent":["// SUBSCRIBED\n.popup.popup--subscribed .popup__content {\n  position: relative;\n  margin: auto;\n}\n\n.popup.visible.popup--subscribed .popup__wash {\n  opacity: 1;\n  pointer-events: all;\n  cursor: pointer;\n}\n\n.popup--subscribed {\n  pointer-events: none;\n}\n\n.popup.popup--subscribed {\n  .popup__text-container {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n\n    .popup__heading {\n      text-transform: unset;\n    }\n  }\n\n  .popup__image {\n    position: relative;\n\n    .image__inner {\n      position: relative;\n\n      .image__img {\n        position: relative;\n      }\n    }\n  }\n}\n\n.popup.visible.popup--subscribed .popup__wash {\n  cursor: default;\n}\n\n@media (max-width: 719px) {\n  .popup.visible.popup--subscribed .popup__wash {\n    position: fixed;\n    pointer-events: all;\n    cursor: pointer;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
